<div class="right-side p-5">

  <div class="row section">
    <form [formGroup]="verifyproposal">

      <div class="card mb-3">
        <div class="card-header"><h2>Proposal Status Section</h2></div>
        <div class="card-body">

          <div class="row mb-3">
            <div class="col-md-6">
              <label for="createdProposalId" class="form-label">Proposal Id</label>
              <input type="text" class="form-control" formControlName="createdProposalId" />
            </div>
            <div class="col-md-6">
              <label for="nameofEnterprise" class="form-label">Name of Enterprise</label>
              <input type="text" class="form-control" formControlName="nameofEnterprise" />
            </div>



          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="pragramNameConduct" class="form-label">Proposal For</label>
              <textarea type="text" rows="3" cols="50" class="form-control" formControlName="pragramNameConduct"></textarea>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-6">
              <label for="bbImplementAgency" class="form-label">Brief Background Implement Agency</label>
              <textarea type="text" rows="3" cols="50" class="form-control" formControlName="bbImplementAgency"></textarea>
            </div>
            <div class="col-md-6">
              <label for="ssProjectImplementAgency" class="form-label">Summary and scale projects implemented</label>
              <textarea type="text" rows="3" cols="50" class="form-control" formControlName="ssProjectImplementAgency"></textarea>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="interventionName" class="form-label">Intervention Name</label>
              <input type="text" class="form-control" formControlName="interventionName" />
            </div>
            <div class="col-md-3">
              <label for="componentName" class="form-label">Component Name</label>
              <textarea type="text" class="form-control" formControlName="componentName"></textarea>
            </div>
            <div class="col-md-3">
              <label for="targetMSME" class="form-label">Target MSME</label>
              <input type="text" class="form-control" formControlName="targetMSME" />
            </div>
            <div class="col-md-3">
              <label for="noOfEvent" class="form-label">No of Events</label>
              <input type="text" class="form-control" formControlName="noOfEvent" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-12">
              <label for="measurableOutcomes" class="form-label">Measurable Outcomes</label>
              <textarea type="text" rows="3" cols="50" class="form-control" formControlName="measurableOutcomes"></textarea>
            </div>
            <div class="col-md-3 d-none">
              <label for="proposedCertificationWorkshops" class="form-label">Proposed Certification Workshops</label>
              <input type="text" class="form-control" formControlName="proposedCertificationWorkshops" />
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-md-3">
              <label for="msmeTargetAchieve" class="form-label">Total MSME Target</label><!--MSME Target Achieve-->
              <input type="text" class="form-control" formControlName="msmeTargetAchieve" />
            </div>
            <div class="col-md-3">
              <label for="msmeTargetBalance" class="form-label">Balance MSME Target</label><!--MSME Target Balance-->
              <input type="text" class="form-control" formControlName="msmeTargetBalance" />
              <span *ngIf="proposalApprovalStatus" class="text-danger">Fund Not Available.</span>
            </div>
            <div class="col-md-3">
              <label for="budgetPerBeneficiary" class="form-label">Budget Per Beneficiary</label>
              <input type="text" class="form-control" formControlName="budgetPerBeneficiary" />
            </div>
            <div class="col-md-3">
              <label for="beneficiariesName" class="form-label">Beneficiaries</label>
              <input type="text" class="form-control" formControlName="beneficiariesName" />
            </div>
          </div>
          <div class="mt-5">
            <mat-tab-group class="mt-3">
              <mat-tab label="Implementation Details">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th (click)="sort('engagementPartnerName')" [class.sorted]="sortColumn === 'engagementPartnerName'">{{ sortColumn === 'engagementPartnerName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Engagement Partner Name</th>
                        <th (click)="sort('districtName')" [class.sorted]="sortColumn === 'districtName'">{{ sortColumn === 'districtName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} District Name </th>
                        <th (click)="sort('noOfWorkshop')" [class.sorted]="sortColumn === 'noOfWorkshop'">{{ sortColumn === 'noOfWorkshop' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} No Of Workshop</th>
                        <th (click)="sort('targets')" [class.sorted]="sortColumn === 'targets'">{{ sortColumn === 'targets' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Targets</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of implementationDetails; index as i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-center">{{ item.engagementPartnerName }}</td>
                        <td class="text-center">{{ item.districtName }}</td>
                        <td class="text-center">{{ item.noOfWorkshop }}</td>
                        <td class="text-center">{{ item.targets }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </mat-tab>


              <mat-tab label="Geography And Timeline">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No. </th>
                        <th (click)="sort('proposedDateTraining')" [class.sorted]="sortColumn === 'proposedDateTraining'">{{ sortColumn === 'proposedDateTraining' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Proposed Date Training</th>
                        <th (click)="sort('proposedDistrict')" [class.sorted]="sortColumn === 'proposedDistrict'">{{ sortColumn === 'proposedDistrict' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Proposed District </th>
                        <th (click)="sort('proposedVenue')" [class.sorted]="sortColumn === 'proposedVenue'">{{ sortColumn === 'proposedVenue' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Proposed Venue (Training location)</th>
                        <th (click)="sort('proposedNoOfWorkshop')" [class.sorted]="sortColumn === 'proposedNoOfWorkshop'">{{ sortColumn === 'proposedNoOfWorkshop' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Proposed no. of workshop per location</th>
                        <th (click)="sort('totalTarget')" [class.sorted]="sortColumn === 'totalTarget'">{{ sortColumn === 'totalTarget' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Totol Target</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of geographyAndTimeline; index as i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-center">{{ item.proposedDateTraining }}</td>
                        <td class="text-center">{{ item.proposedDistrict }}</td>
                        <td class="text-center">{{ item.proposedVenue }}</td>
                        <td class="text-center">{{ item.proposedNoOfWorkshop }}</td>
                        <td class="text-center">{{ item.totalTarget }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </mat-tab>
              <mat-tab label="Training Delivery" class="lbl-fontcolor">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th (click)="sort('detailsCDCC')" [class.sorted]="sortColumn === 'detailsCDCC'">{{ sortColumn === 'detailsCDCC' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Details of Curriculum Design/ Course Content</th>
                        <th (click)="sort('durationWorkshop')" [class.sorted]="sortColumn === 'durationWorkshop'">{{ sortColumn === 'durationWorkshop' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Duration of Workshop (Hours) for each category </th>
                        <th (click)="sort('qualificationTrainers')" [class.sorted]="sortColumn === 'qualificationTrainers'">{{ sortColumn === 'qualificationTrainers' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Qualification of Trainers</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of trainingDelivery; index as i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-center">{{ item.detailsCDCC }}</td>
                        <td class="text-center">{{ item.durationWorkshop }}</td>
                        <td class="text-center">{{ item.qualificationTrainers }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </mat-tab>
              <mat-tab label="Intervention Milestones">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th (click)="sort('milestone')" [class.sorted]="sortColumn === 'milestone'">{{ sortColumn === 'milestone' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Milestone</th>
                        <th (click)="sort('projectStartDate')" [class.sorted]="sortColumn === 'projectStartDate'">{{ sortColumn === 'projectStartDate' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Project Start Date </th>
                        <th (click)="sort('durationInMonth')" [class.sorted]="sortColumn === 'durationInMonth'">{{ sortColumn === 'durationInMonth' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Duration in Months </th>
                        <th (click)="sort('estimatedProjectClosure')" [class.sorted]="sortColumn === 'estimatedProjectClosure'">{{ sortColumn === 'estimatedProjectClosure' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Estimated Project Closure</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of interventionMilestones; index as i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-center">{{ item.milestone }}</td>
                        <td class="text-center">{{ item.projectStartDate }}</td>
                        <td class="text-center">{{ item.durationInMonth }}</td>
                        <td class="text-center">{{ item.estimatedProjectClosure }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </mat-tab>
              <mat-tab label="Detailed Financial">
                <div class="table-responsive">
                  <table class="table table-striped table-bordered table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th (click)="sort('interventionName')" [class.sorted]="sortColumn === 'interventionName'">{{ sortColumn === 'interventionName' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Budget Head</th>
                        <th (click)="sort('cost')" [class.sorted]="sortColumn === 'cost'">{{ sortColumn === 'cost' ? (sortDirection === 'asc' ? '▲' : '▼') : '' }} Cost </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of detailedFinancials; index as i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-center">{{ item.interventionName }}</td>
                        <td class="text-center">{{ item.cost }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </mat-tab>

            </mat-tab-group>

            <div>
              <div class="row">
                <div class="col-md-3">
                  <label for="statusSelect">Select Status<span class="text-danger">*</span></label>
                  <select class="form-select" formControlName="status" (change)="onStatusChange()">
                    <option value="">--Select Option--</option>
                    <option *ngFor="let option of status" [value]="option.id">
                      {{ option.text }}
                    </option>
                  </select>
                  <div *ngIf="f['status'].touched && f['status'].invalid" class="text-danger">
                    Select Status is required.
                  </div>
                </div>

                <div *ngIf="isShowApprovalFields">
                  <div class="col-md-3">
                    <label class="text-dark">From Date <span class="text-danger">*</span></label>
                    <input type="date"
                           id="txtFromDate"
                           formControlName="fromDate"
                           placeholder="Enter From Date"
                           class="form-control"
                           (change)="onFromDateChange(); calculateDuration()"/>

                    <!-- Optional error message -->
                    <div *ngIf="isSubmitted && f['fromDate'].invalid">
                      <!-- Required error -->
                      <div *ngIf="f['fromDate'].errors?.['required']" class="text-danger">
                        From Date is required.
                      </div>
                    </div>
                  </div>

                  <div class="col-md-3">
                    <label class="text-dark">To Date<span class="text-danger">*</span></label>
                    <input type="date"
                           id="txtToDate"
                           formControlName="toDate"
                           [min]="minToDate"
                           placeholder="Enter To Date"
                           (change)="calculateDuration()"
                           class="form-control" />
                    <!-- Optional error message -->
                    <div *ngIf="isSubmitted && f['toDate'].invalid">
                      <!-- Required error -->
                      <div *ngIf="f['toDate'].errors?.['required']" class="text-danger">
                        To Date is required.
                      </div>
                    </div>
                  </div>

      <div class="col-md-3">

  <label for="targetMSME" class="form-label">
    Proposed Target MSME
  </label>

  <input
    type="number"
    class="form-control"
    formControlName="approvedTargetMSME"
    (input)="validateApprovedTargetMSME($event)"
  />

  <small
    class="text-danger"
    *ngIf="
      verifyproposal.get('approvedTargetMSME')?.hasError('required')
      && verifyproposal.get('approvedTargetMSME')?.touched
    "
  >
    Target MSME is required
  </small>
  

  <small
    class="text-danger"
    *ngIf="
      verifyproposal.get('approvedTargetMSME')?.hasError('min')
      && verifyproposal.get('approvedTargetMSME')?.touched
    "
  >
    Value must be greater than 0
  </small>

  <small
    class="text-danger"
    *ngIf="
      verifyproposal.get('approvedTargetMSME')?.errors?.['exceedsTarget']
    "
  >
    Value cannot exceed {{ maxTargetMSME }}
  </small>

</div>



      
                  <div class="col-md-3">
                    <label for="approvedTargetMSME" class="form-label">Approved Target MSME</label>
                    <input type="text" class="form-control" min="1" formControlName="approvedTargetMSME" (input)="validateApprovedTargetMSME($event)" />
        
                    <div *ngIf="verifyproposal.get('approvedTargetMSME')?.errors?.['required']">
                      <small class="text-danger">Approved Target MSME is required..</small>
                    </div>
                    <div *ngIf="verifyproposal.get('approvedTargetMSME')?.errors?.['min']">
                      <small class="text-danger">Minimum target value should not be less than 1.</small>
                    </div>
                    <div *ngIf="verifyproposal.get('approvedTargetMSME')?.errors?.['exceedsTarget']">
                      <small class="text-danger">Value cannot exceed {{ maxTargetMSME }}.</small>
                    </div>
                    <!--rp ends-->
                  </div>
                  <div class="col-md-3">
                    <label for="Duration" class="form-label">Duration (Months):</label>
                    <input type="text" class="form-control" formControlName="duration" readonly />
                  </div>
                  <div class="col-md-3">
                    <label for="Days" class="form-label">Days:</label>
                    <input type="text" class="form-control" formControlName="days" readonly />
                  </div>
                </div>
              </div>

              <!--<div class="row mt-4">
              <div class="col-md-4">
                <label for="workOrderCertificate">Upload Work Order Certificate (PDF, max 10 MB):<span class="text-danger">*</span> </label>
                <input type="file" class="form-control" id="workOrderCertificate" (change)="onWorkOrderFileChange($event)" accept=".pdf" formControlName="workOrderCertificate" />

                <div *ngIf="isSubmitted && verifyproposal.get('workOrderCertificate')?.invalid" class="text-danger">
                  <div *ngIf="verifyproposal.get('workOrderCertificate')?.errors?.['required']">
                    Upload File is required.
                  </div>
                  <div *ngIf="uploadError" class="alert alert-danger">{{ uploadError }}</div>-->
              <!--</div>-->
              <!--<div class="mt-2">
              -->
              <!--<p><strong>Uploaded:</strong> {{ workOrderCertificate }}</p>-->
              <!--<button type="button" class="btn btn-primary btn-sm" (click)="openFile()">View</button>
                </div>
              </div>
              </div>-->
              <div class="row mt-4" *ngIf="isShowApprovalFields">
                <div class="col-md-4" *ngIf="this.UserType == 'MSSIDC' && this.approvalStatus!='Approved'">
                  <label for="workOrderCertificate">Upload Work Order Certificate (PDF, max 10 MB):<span class="text-danger">*</span></label>
                  <input type="file" class="form-control" id="workOrderCertificate" (change)="onWorkOrderFileChange($event)" accept=".pdf" />

                  <div *ngIf="isSubmitted && verifyproposal.get('workOrderCertificate')?.invalid" class="text-danger">
                    <div *ngIf="verifyproposal.get('workOrderCertificate')?.errors?.['required']">
                      File is required.
                    </div>
                    <div *ngIf="uploadError" class="alert alert-danger">{{ uploadError }}</div>
                  </div>

                  <div class="mt-2">
                    <p *ngIf="fileName"><strong>Uploaded File:</strong> {{ fileName }}</p>
                    <button type="button" class="btn btn-primary btn-sm" (click)="openFile()" [disabled]="!fileUrl">View</button>
                  </div>
                </div>


                <!-- Work Order Download -->
                <div class="col-md-3" *ngIf="this.approvalStatus == 'Approved'">
                  <label class="text-dark">Work Order Download</label>
                  <div>
                    <a class="text-decoration-none btn btn-warning btn-sm mt-1" *ngIf="verifyproposal.get('workOrderCertificate')?.value"
                       (click)="onDownload(verifyproposal.get('workOrderCertificate')?.value, verifyproposal.get('workOrderCertificate')?.value); $event.preventDefault()"
                       style="text-decoration: underline; cursor: pointer">
                      <i class="bi bi-download"></i> Download
                    </a>
                    <button class="btn btn-primary btn-sm mt-1 mx-2" *ngIf="verifyproposal.get('workOrderCertificate')?.value"
                            (click)="openFilePreviewDialog(verifyproposal.get('workOrderCertificate')?.value, verifyproposal.get('workOrderCertificate')?.value)">
                      <i class="bi bi-eye"></i> View File
                    </button>
                    <span *ngIf="!verifyproposal.get('workOrderCertificate')?.value" class="text-info">File Not Found!</span>
                  </div>
                </div>
              </div>



              <!-- Proposal Download -->
              <div class="row mt-4">
                <div class="col-md-3">
                  <label class="text-dark">Proposal Download</label>
                  <div>
                    <a class="text-decoration-none btn btn-warning btn-sm mt-1" *ngIf="DocumentName"
                       (click)="onDownload(DocumentPath,DocumentName); $event.preventDefault()"
                       style="text-decoration: underline; cursor: pointer">
                      <i class="bi bi-download"></i> Download
                    </a>&nbsp;&nbsp;
                    <button class="btn btn-primary btn-sm mt-1" *ngIf="DocumentPath"
                            (click)="openFilePreviewDialog(DocumentPath, DocumentName)">
                      <i class="bi bi-eye"></i> View File
                    </button>
                    <span *ngIf="!DocumentName" class="text-info">File Not Found!</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 mt-3">
                <div class="col-md-6">
                  <label for="lblRemark">Remark <span class="text-danger">*</span></label>
                  <textarea id="textarea" formControlName="remarks" rows="4" cols="80" maxlength="200" placeholder="Type your comments" class="form-control"> </textarea>

                  <div *ngIf="f['remarks'].touched && f['remarks'].invalid" class="text-danger">
                    <div *ngIf="f['remarks'].errors?.['required']">Remark is required.</div>
                    <div *ngIf="f['remarks'].errors?.['maxlength']">Remark cannot exceed 200 characters.</div>
                  </div>
                </div>
              </div>


              <div class="row">
                <div class="col-md-4">
                  <button [hidden]="proposalApprovalStatus" *ngIf="action" class="btn btn-success me-2" (click)="submit()">Submit</button>
                  <button class="btn btn-info" (click)="back()">Back</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </form>
  </div>
</div>
